import React, { useState } from "react";
import Team from "../../components/about/Team";
import Partners from "../../components/partners/Partners";
import About_news from "../../components/blog/about_news";
import Story from "../../components/about/Story";
import Head from "next/head";
import Meta from "../../components/Meta";
import Awards from "../../components/partners/Awards";
import Calltoaction from "../../components/calltoaction";
import Features from "../../components/features/features";

const About = () => {
  return (
    <>
    {/* <p>asudhiaushdiauhsdiauhsiduhasiudhaishdiashdiahs</p> */}
      <Meta title="Acerca de CIRSYS Tech | Desarrollamos tecnología para el beneficio social." desc={"En CIRSYS buscamos crear tecnología para un mundo más sostenible. Somos una empresa que aporta valor a los negocios desarrollando proyectos con Inteligencia Artificial, Robotica Social, Automatización, desarrollo de Hardware y Software."} keyword={"Inteligencia Artificial, Robotica Social, Automatización, desarrollo de Hardware y Software, proyectos, irbin, cirsys, cirsys tech, tecnología, medio ambiente"} />
      {/* <!-- Page title --> */}
      <section className="relative pt-24 lg:pb-96">
        <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden hidden">
          <img
            src="/images/gradient_light.jpg"
            alt="gradient"
            className="h-full w-full"
          />
        </picture>
        <div className="container">
          {/* <!-- Page Title --> */}
          <div className="mx-auto max-w-6xl py-16 text-center">
            <p className="dark:text-accent text-accent pb-6 text-lg leading-normal">
              CIRSYS TECH
            </p>
            <h1 className="font-display text-white mb-8 text-4xl font-medium dark:text-white">
              {"'' Utilizamos un enfoque ágil y desarrollamos soluciones tecnológicas con impacto social y ambiental ''"}
            </h1>
          </div>
        </div>
      </section>
      {/* <!-- Intro / Statistics --> */}

      <section className="pb-24">
        <div className="container">
          {/* <!-- Video Lightbox --> */}
          <figure className="before:bg-jacarta-900/25 rounded-xl relative mt-16 overflow-hidden rounded-3xl before:absolute before:inset-0 lg:-mt-96">
            <img
              src="/images/about/about-cirsys-1.png"
              className="w-full"
              alt="acerca cirsys"
            />
          </figure>

          {/* <!-- Statistics --> */}
          <div className="pt-24">
            <div className="grid grid-cols-2 md:grid-cols-4">
              <div className="mb-10 text-center">
                <span className="font-display text-accent block text-5xl dark:text-accent">
                  2018
                </span>
                <span className="dark:text-jacarta-300 text-jacarta-300 block">Fundada</span>
              </div>
              <div className="mb-10 text-center">
                <span className="font-display text-accent block text-5xl dark:text-accent">
                  28
                </span>
                <span className="dark:text-jacarta-300 text-jacarta-300 block">
                  Proyectos desarrollados
                </span>
              </div>
              <div className="mb-10 text-center">
                <span className="font-display text-accent block text-5xl dark:text-accent">
                  +50
                </span>
                <span className="dark:text-jacarta-300 text-jacarta-300 block">
                  Clientes satisfechos
                </span>
              </div>
              <div className="mb-10 text-center">
                <span className="font-display text-accent block text-5xl dark:text-accent">
                  15
                </span>
                <span className="dark:text-jacarta-300 text-jacarta-300 block">Aplicaciones prácticas</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Story compFor="about" />
      <Awards />
      <Team />
      <Calltoaction />
      <Features />
    </>
  );
};

export default About;
